var _rect, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "5vw",
    height: "5vw",
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#F4F5F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 38H30.5C30.2348 38 29.9804 37.8946 29.7929 37.7071C29.6054 37.5196 29.5 37.2652 29.5 37V30C29.5 29.7348 29.6054 29.4804 29.7929 29.2929C29.9804 29.1054 30.2348 29 30.5 29H37.5C37.7652 29 38.0196 29.1054 38.2071 29.2929C38.3946 29.4804 38.5 29.7348 38.5 30V37C38.5 37.2652 38.3946 37.5196 38.2071 37.7071C38.0196 37.8946 37.7652 38 37.5 38Z",
    fill: "#3050F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 51H30.5C30.2348 51 29.9804 50.8946 29.7929 50.7071C29.6054 50.5196 29.5 50.2652 29.5 50V43C29.5 42.7348 29.6054 42.4804 29.7929 42.2929C29.9804 42.1054 30.2348 42 30.5 42H37.5C37.7652 42 38.0196 42.1054 38.2071 42.2929C38.3946 42.4804 38.5 42.7348 38.5 43V50C38.5 50.2652 38.3946 50.5196 38.2071 50.7071C38.0196 50.8946 37.7652 51 37.5 51Z",
    fill: "#3050F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 30H51.5V32H41.5V30Z",
    fill: "#2EC5CE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5 43H41.5V45H51.5V43Z",
    fill: "#2EC5CE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5 48H41.5V50H51.5V48Z",
    fill: "#B1C7FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5 35H41.5V37H51.5V35Z",
    fill: "#B1C7FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.e9271c18.svg";
export { ForwardRef as ReactComponent };